/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ThirdPartyTicketBaseQuery = {
    /**
     * Card number.
     */
    cardNumber?: string;
    /**
     * Card type.
     */
    cardType?: ThirdPartyTicketBaseQuery.cardType;
    /**
     * Ticket state.
     */
    state?: ThirdPartyTicketBaseQuery.state;
    /**
     * Filter data by tenant FTP username
     */
    tenantFTPName?: string;
    /**
     * Client current timezone offset in minutes. Is required.
     */
    timezoneOffset?: number;
    /**
     * Sort by. Default: id
     */
    sortBy?: string;
    /**
     * Sort order descendent. Default: true
     */
    sortDesc?: boolean;
    /**
     * Sort with locale. Default: sk
     */
    sortLocale?: string;
    /**
     * Page Size. Default: 25
     */
    limit?: number;
    /**
     * Offsetting x items. Default: 0
     */
    offset?: number;
};
export namespace ThirdPartyTicketBaseQuery {
    /**
     * Card type.
     */
    export enum cardType {
        BANK_CARD = 'BANK_CARD',
        IN_CARD = 'IN_CARD',
        HAULIER_CARD = 'HAULIER_CARD',
        MOBILE_PHONE = 'MOBILE_PHONE',
    }
    /**
     * Ticket state.
     */
    export enum state {
        CANCELLED = 'CANCELLED',
        EXPIRED = 'EXPIRED',
        ACTIVE = 'ACTIVE',
        FUTURE = 'FUTURE',
    }
}

